import { render } from "./Register2Page.vue?vue&type=template&id=4dda2696"
import script from "./Register2Page.vue?vue&type=script&lang=js"
export * from "./Register2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__